import React, { useEffect, useState } from 'react';
import bike from '../../Assets/Images/hatchback_683088.png';
import { Drawer } from 'antd';
import EditCarDetails from './DrawerComponents/EditCarDetails';
import NcbDrawer from './DrawerComponents/NcbDrawer';
import IdvComp from './DrawerComponents/IdvComp';

function EditCarRequest({ storageChange, setStorageChange }) {
    const [openVehicle, setOpenVehicle] = useState(false);
    const [openIdv, setOpenIdv] = useState(false);
    const [openNcb, setopenNcb] = useState(false);
    const [openAddOn, setopenAddOn] = useState(false)
    const [formData, setFormData] = useState({
        make: null,
        model: null,
        variant: null,
        year: null,
        rto: null,
        makeLabel: null,
        modelLabel: null,
        policy: null,
        previousInsurer: null,
        previousPolicy: null,
        ncb: null,
        previousPolicyExpiryDate: null,
        previousClaims: null,
        registrationDate: null,
        licensePlateNumber: null,
        defaultIdv: null,
        minimumIdv: null,
        maximumIdv: null,
    })
    useEffect(() => {  // to set data from from the sessionStorage
        const data = JSON.parse(sessionStorage.getItem("CarDetails"))
        const quoteRequestData = JSON.parse(sessionStorage.getItem("CarQuotationRequest"))

        const idvDetails = JSON.parse(sessionStorage.getItem("idvDetails"))
        if (idvDetails) {
            setFormData(prev => ({
                ...prev,
                make: data.make,
                model: data.model,
                variant: data.variant,
                rto: data.rto,
                year: quoteRequestData.manufactureDate,
                makeLabel: data.makeLabel,
                modelLabel: data.modelLabel,
                policy: data.policy,
                previousInsurer: data.previousInsurer,
                previousPolicy: data.previousPolicy,
                ncb: data.ncb,
                previousPolicyExpiryDate: data.previousPolicyExpiryDate,
                previousClaims: data.previousClaims,
                registrationDate: data.registrationDate,
                licensePlateNumber: data.licensePlateNumber,
                idv: idvDetails.idv ? idvDetails.idv : null,
                defaultIdv: idvDetails.defaultIdv ? idvDetails.defaultIdv : null,
                minimumIdv: idvDetails.minimumIdv ? idvDetails.minimumIdv : null,
                maximumIdv: idvDetails.maximumIdv ? idvDetails.maximumIdv : null,
            }))
        } else {
            setFormData(prev => ({
                ...prev,
                make: data.make,
                model: data.model,
                variant: data.variant,
                rto: data.rto,
                year: quoteRequestData.manufactureDate,
                makeLabel: data.makeLabel,
                modelLabel: data.modelLabel,
                policy: data.policy,
                previousInsurer: data.previousInsurer,
                previousPolicy: data.previousPolicy,
                ncb: data.ncb,
                previousPolicyExpiryDate: data.previousPolicyExpiryDate,
                previousClaims: data.previousClaims,
                registrationDate: data.registrationDate,
                licensePlateNumber: data.licensePlateNumber,
                idv: 0,
                defaultIdv: 0,
                minimumIdv: 0,
                maximumIdv: 0,
            }))
        }

        console.log(data, "line 13")
    }, [setFormData])
    const [addOn, setAddon] = useState({
        zeroDepreciation: false,
        engineProtect: false,
        consumablesSelection: false,
    });
    useEffect(() => {
        const data = JSON.parse(sessionStorage.getItem("CarQuotationRequest"));
        setAddon(prev => ({
            ...prev,
            zeroDepreciation: data.zeroDepreciation,
            engineProtect: data.engineProtect,
            consumablesSelection: data.consumablesSelection
        }))
    }, [])
    const toggleCheckbox = (addOn) => {
        setAddon(prevState => ({
            ...prevState,
            [addOn]: !prevState[addOn]
        }));

        const data = JSON.parse(sessionStorage.getItem("CarQuotationRequest"));
        const updatedData = {
            ...data,
            [addOn]: !data[addOn]
        };

        sessionStorage.setItem("CarQuotationRequest", JSON.stringify(updatedData));
        setStorageChange(true);
    };
    const showVehicleDrawer = () => {
        setOpenVehicle(true);
    };

    const showIdvDrawer = () => {
        setOpenIdv(true);
    };
    const showNcbDrawer = () => {
        setopenNcb(true);
    };
    const showAddOnDrawer = () => {
        setopenAddOn(true);
    };

    const onClose = () => {
        setOpenVehicle(false);
        setOpenIdv(false);
        setopenNcb(false)
        setopenAddOn(false)
    };
    const handleSubmitUpdate = () => {
        // Retrieve the existing data from sessionStorage
        const data = JSON.parse(sessionStorage.getItem("CarQuotationRequest"));

        // Update the data with new form values
        const updatedData = {
            ...data,
            MakeID: formData.make,
            ModelID: formData.model,
            VariantID: formData.variant,
            previousPolicyExpiryDate: formData.previousPolicyExpiryDate,
            InsurerProductID: formData.policy,
            PreviousPolicyTypeID: formData.previousPolicy,
            NCBID: formData.ncb,
            isClaimInLastYear: formData.previousClaims,
            manufactureDate: formData.year,
            minimumIdv: formData.minimumIdv,
            maximumIdv: formData.maximumIdv,
            idv: formData.idv,
            defaultIdv: formData.defaultIdv
        };
        // Store the updated data back in sessionStorage
        sessionStorage.setItem("CarQuotationRequest", JSON.stringify(updatedData));
        sessionStorage.setItem("CarDetails", JSON.stringify(formData))
        setStorageChange(true)
        setOpenVehicle(false)
        setopenNcb(false)
        setOpenIdv(false)
    }
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768); // Adjust the breakpoint as needed
        };
        // Set initial mobile state on component mount
        handleResize();

        // Add resize event listener to update mobile state
        window.addEventListener('resize', handleResize);

        // Cleanup event listener on component unmount
        return () => window.removeEventListener('resize', handleResize);
    }, []);
    return (
        isMobile ?
            (
                <>
                    <div className='mobile-topBar'>
                        <div className='motor-edit-mobile-wrapper'>
                            <div className='edit-options text-center' onClick={showVehicleDrawer}>
                                Motor Details
                            </div>
                            <Drawer
                                title="Your Vehicle Details"
                                placement='bottom'
                                height={520}
                                zIndex={3000}
                                onClose={onClose}
                                style={{ padding: '15px 0px' }}
                                visible={openVehicle}
                            >
                                <EditCarDetails formData={formData} setFormData={setFormData} />
                                <div className='wrapper-div-rto'>
                                    <button type='button' onClick={handleSubmitUpdate} className='submit-button-filter update-button-edit'>Update</button>
                                </div>
                            </Drawer>
                            <div className='edit-options text-center' onClick={showIdvDrawer}>
                                IDV Details
                            </div>
                            <Drawer
                                title="Idv"
                                placement='bottom'
                                height={520}
                                zIndex={3000}
                                onClose={onClose}
                                style={{ padding: '15px 0px' }}
                                visible={openIdv}
                            >
                                <IdvComp formData={formData} setFormData={setFormData} />
                            </Drawer>

                            <div className='edit-options text-center' onClick={showNcbDrawer}>
                                Policy Details
                            </div>
                            <Drawer
                                title="No Claim Bonus (NCB)"
                                placement='bottom'
                                height={520}
                                zIndex={3000}
                                onClose={onClose}
                                style={{ padding: '15px 0px' }}
                                visible={openNcb}
                            >
                                <NcbDrawer formData={formData} setFormData={setFormData} />
                                <div className='wrapper-div-rto'>
                                    <button type='button' onClick={handleSubmitUpdate} className='submit-button-filter update-button-edit'>Update</button>
                                </div>
                            </Drawer>
                        </div>
                    </div>
                </>
            ) :
            (
                <>
                    <div className='bike-edit-wrapper'>
                        <h5 className='bike-details-title'>
                            Your vehicle details
                            <span span className="edit-link" onClick={showVehicleDrawer} > Edit</span>
                        </h5 >
                        <div className='edit-vechile-detail'>
                            <div className='bike-image-div mt-2'>
                                <img className='bike-image' src={bike} alt="Bike" />
                            </div>
                            <div className="vehicleTxt">
                                <em>Vehicle</em>
                                <span>{formData.makeLabel} {formData.modelLabel}</span>
                            </div>
                        </div>
                        <div className="vehicle-rto-edit mt-3">
                            <ul>
                                <li>Year<b>{formData.year}</b></li>
                                <li>RTO<b>DL3S (New Delhi)</b></li>
                            </ul>
                        </div>
                    </div >

                    <Drawer
                        title="Your Vehicle Details"
                        placement='left'
                        zIndex={3000}
                        onClose={onClose}
                        style={{ padding: '15px 0px' }}
                        visible={openVehicle}
                    >
                        <EditCarDetails formData={formData} setFormData={setFormData} />
                        <div className='wrapper-div-rto'>
                            <button type='button' onClick={handleSubmitUpdate} className='submit-button-filter update-button-edit'>Update</button>
                        </div>
                    </Drawer>

                    <div className='bike-edit-wrapper'>
                        <h5 className='bike-details-title'>
                            Insured value (IDV)
                            <span className="edit-link" onClick={showIdvDrawer}>Edit</span>
                        </h5>
                        <h4 className='idv-text ms-3'>Currently set for lowest price: <b>₹{formData.idv}</b></h4>
                    </div>

                    <Drawer
                        title="Idv"
                        placement='left'
                        zIndex={3000}
                        onClose={onClose}
                        style={{ padding: '15px 0px' }}
                        visible={openIdv}
                    >
                        <IdvComp formData={formData} setFormData={setFormData} />
                        <div className='wrapper-div-rto mt-5'>
                            <button type='button' onClick={handleSubmitUpdate} className='submit-button-filter update-button-edit'>Update</button>
                        </div>
                    </Drawer>

                    <div className='bike-edit-wrapper'>
                        <h5 className='bike-details-title'>
                            Update Policy Details
                            <span className="edit-link" onClick={showNcbDrawer}>Edit</span>
                        </h5>
                        <div>
                            <ul className="claim-listing">
                                <li>Your NCB this year will be <b>0%</b></li>
                                <li>Last year your NCB was <b>0%</b></li>
                                <li>Did you take claims in last policy? <b>{formData.previousClaims}</b></li>
                            </ul>
                        </div>
                    </div>

                    <Drawer
                        title="No Claim Bonus (NCB)"
                        placement='left'
                        zIndex={3000}
                        onClose={onClose}
                        style={{ padding: '15px 0px' }}
                        visible={openNcb}
                    >
                        <NcbDrawer formData={formData} setFormData={setFormData} />
                        <div className='wrapper-div-rto'>
                            <button type='button' onClick={handleSubmitUpdate} className='submit-button-filter update-button-edit'>Update</button>
                        </div>
                    </Drawer>

                    <div className='bike-edit-wrapper'>
                        <h4 className='bike-details-title'>Select Add On's</h4>
                        <div className='container'>
                            <div className={`custom-checkbox-disease mb-2 ${addOn.zeroDepreciation ? 'checked' : ''}`} onClick={() => toggleCheckbox('zeroDepreciation')}>
                                <div className="checkbox-disease">
                                    {addOn.zeroDepreciation && <span className="checkmark-disease">&#10003;</span>}
                                </div>
                                <div className="label">Zero Depreciation</div>
                            </div>
                            <div className={`custom-checkbox-disease mb-2 ${addOn.engineProtect ? 'checked' : ''}`} onClick={() => toggleCheckbox('engineProtect')}>
                                <div className="checkbox-disease">
                                    {addOn.engineProtect && <span className="checkmark-disease">&#10003;</span>}
                                </div>
                                <div className="label">Engine Protect</div>
                            </div>
                            <div className={`custom-checkbox-disease mb-2 ${addOn.consumablesSelection ? 'checked' : ''}`} onClick={() => toggleCheckbox('consumablesSelection')}>
                                <div className="checkbox-disease">
                                    {addOn.consumablesSelection && <span className="checkmark-disease">&#10003;</span>}
                                </div>
                                <div className="label">Consumables</div>
                            </div>
                        </div>
                    </div>
                </>
            )

    );
}

export default EditCarRequest;
